import app from '$$app';
import Dnd from '../../grid/dnd';

export default instance => {
  const helper = instance.utils.dom;
  const customColumnsTypes = ['custom_multiselect', 'custom_resources', 'custom_tags'];
  let activeTaskId = null;
  let activeColumnType = null;

  return (taskId, event) => {
    const chartState = instance.getState();
    const isChartDnD = chartState.drag_mode === 'move' || chartState.drag_mode === 'resize';

    if (taskId && !Dnd.isDragging && !isChartDnD && instance.isTaskExists(taskId)) {
      const node = helper.closest(event.target, '.gantt_cell');
      const columnType = node ? customColumnsTypes.find(type => type === node.dataset.type) : null;

      const isCustomColumnCell = node
        ? !!columnType && !!node.querySelector('.text_value').children.length && !helper.hasClass(node, 'gantt_focused')
        : false;

      if (activeTaskId && (activeTaskId !== taskId || activeColumnType !== columnType || !isCustomColumnCell)) {
        activeTaskId = null;
        activeColumnType = null;

        app.trigger('hideCustomColumnPreviewList');
      }

      if (isCustomColumnCell && !activeTaskId && !activeColumnType) {
        const task = instance.getTask(taskId);

        activeTaskId = taskId;
        activeColumnType = columnType;

        app.trigger('showCustomColumnPreviewList', node.getBoundingClientRect(), task.id, task.gantt_id, +node.dataset.name);
      }
    } else if ((activeTaskId || activeColumnType) && !helper.closest(event.target, '#task_custom_column_preview')) {
      activeTaskId = null;
      activeColumnType = null;

      app.trigger('hideCustomColumnPreviewList');
    }
  };
};
